import { Github, Linkedin, Mail } from 'lucide-react';

const links = [
  { label: 'Articulos', href: '#articulos' },
  { label: 'Proyectos', href: '#proyectos' },
  { label: 'Contacto', href: '#contacto' },
];

export function Layout({ children }) {
  return (
    <div className="app-shell">
      <header className="site-header">
        <a className="brand" href="#inicio" aria-label="Inicio">
          <span className="brand-mark">BE</span>
          <span>Backend Notes</span>
        </a>

        <nav aria-label="Principal">
          {links.map((link) => (
            <a key={link.href} href={link.href}>
              {link.label}
            </a>
          ))}
        </nav>

        <div className="header-actions" aria-label="Redes profesionales">
          <a href="https://github.com/Franki94" 
          target="_blank" rel="noopener noreferrer" aria-label="GitHub">
            <Github size={18} />
          </a>
          <a href="https://www.linkedin.com/in/becker-utia-lopez-768bb37a/" 
          target="_blank" rel="noopener noreferrer" aria-label="LinkedIn">
            <Linkedin size={18} />
          </a>
          <a href="mailto:tu-email@example.com" aria-label="Email">
            <Mail size={18} />
          </a>
        </div>
      </header>

      <main>{children}</main>
    </div>
  );
}
